import { PropType, defineComponent, ref } from 'vue'

import { CsPrimaryButton, CsSecondaryButton } from '@sunrise/components'
import { MsMailOpen } from '@sunrise/icons'
import { useGlobalStore } from '@sunrise/shared'
import { MLM, track } from '@sunrise/tracking'

import { DecoratedContactDetails } from '../../ts/mapper/decoratedEstateDetailMapper.interface'
import { useDetailStore } from '../../ts/store/detailStoreModule/detailStoreModule'
import { ActionIds } from '../../ts/tracking/mlmActionIds.enum'

import { ContactNumberType } from '../MsDetailModalCall/MsDetailModalCall.enum'
import MsDetailModalCall from '../MsDetailModalCall/MsDetailModalCall.vue'
import { buildMlmTrackingData as buildCallMLMTrackingData } from '../MsDetailModalCall/MsDetailModalCallTracking'
import MsDetailModalContact from '../MsDetailModalContact/MsDetailModalContact.vue'
import { ContactBtnPosition } from './MsDetailContactBtnGroup.enum'
import { buildMlmTrackingData, buildTealiumTrackingData } from './MsDetailContactBtnGroupTracking'

export default defineComponent({
    name: 'MsDetailContactBtnGroup',
    components: { MsDetailModalCall, MsDetailModalContact, CsPrimaryButton, CsSecondaryButton, MsMailOpen },
    props: {
        exposeeId: {
            type: Number,
            required: true,
        },
        contact: {
            type: Object as PropType<DecoratedContactDetails>,
            required: true,
        },
        position: {
            type: String as PropType<ContactBtnPosition>,
            required: true,
        },
        componentId: {
            type: String,
            required: true,
        },
        stickyBarBottom: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const requestContext = useGlobalStore().requestContext
        const currentUrl = requestContext?.url.href || ''
        const { offerType, estateType } = useDetailStore()
        const callModalIsVisible = ref<boolean>(false)
        const contactModalIsVisible = ref<boolean>(false)

        function getSinglePhoneNumber(): string {
            const contact = props.contact.contactNumbers[0]
            return contact &&
                (contact.label === ContactNumberType.PHONENUMBER || contact.label === ContactNumberType.MOBILENUMBER)
                ? `tel:${contact.value}`
                : ''
        }

        function openContactModal(): void {
            contactModalIsVisible.value = true
            trackOpenModal()
        }

        function closeContactModal(): void {
            contactModalIsVisible.value = false
        }

        function openCallModal(): void {
            callModalIsVisible.value = true
            trackOpenModal()
        }

        function closeCallModal(): void {
            callModalIsVisible.value = false
        }

        function trackOpenModal(): void {
            const isContactModal = contactModalIsVisible.value
            const adType = `${offerType?.toLowerCase()}_${estateType?.toLowerCase()}`

            const tealiumData = buildTealiumTrackingData(props.exposeeId, props.position, isContactModal, adType)
            track(tealiumData)

            const mlmData = buildMlmTrackingData(props.componentId, currentUrl, props.exposeeId, isContactModal)
            MLM.trackClick(mlmData)
        }

        function shouldHaveCallModalButton(): boolean {
            return (
                requestContext?.device.desktop ||
                props.contact.contactNumbers.length > 1 ||
                props.contact.contactNumbers[0].label === ContactNumberType.FAXNUMBER
            )
        }

        function trackPhoneNumberClick() {
            const mlmTrackingData = buildCallMLMTrackingData(
                ActionIds.CALL_NUMBER_CLICK,
                'M_Immo_Detail',
                currentUrl,
                props.exposeeId,
            )
            MLM.trackClick(mlmTrackingData)
        }

        return {
            callModalIsVisible,
            contactModalIsVisible,
            getSinglePhoneNumber,
            closeCallModal,
            openCallModal,
            closeContactModal,
            openContactModal,
            shouldHaveCallModalButton,
            trackPhoneNumberClick,
            ContactBtnPosition,
        }
    },
})
